import {createClient} from "@sanity/client";
import imageUrlBuilder from "@sanity/image-url";

export const sanityClient = createClient({
  projectId:
    process.env.REACT_APP_SANITY_PROJECT_ID || "96i6ragt",
  dataset: process.env.REACT_APP_SANITY_DATASET || "production",
  apiVersion: "2024-01-01",
  useCdn: true,
});

const builder = imageUrlBuilder(sanityClient);

export function urlFor(source) {
  return builder.image(source);
}

const EVENT_FIELDS = `
  _id,
  titre,
  date,
  lieu,
  description,
  images[]{
    _key,
    asset,
    caption,
    alt,
    "url": asset->url
  },
  "compteRenduUrl": compteRendu.asset->url,
  "compteRenduFilename": compteRendu.asset->originalFilename
`;

const GALERIE_FIELDS = `
  _id,
  titre,
  date,
  description,
  images[]{
    _key,
    asset,
    caption,
    alt
  }
`;

export async function getUpcomingEvents() {
  const now = new Date().toISOString();
  return sanityClient.fetch(
    `*[_type == "event" && date >= $now] | order(date asc) {${EVENT_FIELDS}}`,
    {now}
  );
}

export async function getPastEvents() {
  const now = new Date().toISOString();
  return sanityClient.fetch(
    `*[_type == "event" && date < $now] | order(date desc) {${EVENT_FIELDS}}`,
    {now}
  );
}

export async function getGaleries() {
  return sanityClient.fetch(
    `*[_type == "galerie"] | order(coalesce(date, _createdAt) desc) {${GALERIE_FIELDS}}`
  );
}

const PAGE_SECTION_FIELDS = `
  _id,
  slug,
  titre,
  contenu,
  image{
    asset,
    alt,
    "url": asset->url
  },
  sousSections[]{
    _key,
    titre,
    contenu,
    image{
      asset,
      alt,
      "url": asset->url
    }
  }
`;

export async function getPageSections() {
  const docs = await sanityClient.fetch(
    `*[_type == "pageSection"]{${PAGE_SECTION_FIELDS}}`
  );
  const bySlug = {};
  for (const doc of docs || []) {
    if (doc.slug) bySlug[doc.slug] = doc;
  }
  return bySlug;
}
